import { fbt } from 'fbtee'
import { Button } from '@/components/ui/button'
import { openFeedback } from '@/lib/feedbackBridge'
import { retryButtonLabel, goHomeButtonLabel } from '@/lib/commonStrings'
import { isRestartInFlight } from '@/lib/webViewRestart'

export function ErrorFallback({ resetError }: { resetError: () => void }) {
  // An OTA/recovery restart terminates Firestore while the outgoing WebView is
  // still on screen, so in-flight reads throw into the boundary. That WebView is
  // about to be replaced — show a blank page, not a crash screen.
  if (isRestartInFlight()) return <div className="min-h-dvh bg-background" />

  return (
    <div className="min-h-dvh bg-background flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold tracking-tight">
          {fbt('Something broke on this page', 'Heading on the error boundary fallback page')}
        </h1>
        <p className="text-muted-foreground">
          {fbt(
            "We've been notified. You can try reloading or head back home.",
            'Body text on the error boundary fallback page suggesting next steps',
          )}
        </p>
        <div className="flex flex-wrap gap-2 justify-center">
          <Button variant="outline" onClick={resetError}>
            {retryButtonLabel()}
          </Button>
          <Button onClick={() => (window.location.href = '/')}>
            {goHomeButtonLabel()}
          </Button>
          <Button variant="ghost" onClick={() => openFeedback()}>
            {fbt('Report issue', 'Button on error page to open feedback dialog')}
          </Button>
        </div>
      </div>
    </div>
  )
}
